import { apiClient } from "./apiClient";
import { ILoggedUser } from "../features/user/interfaces/IUserInterface";
import axios from "axios";

export async function getLoggedUser(): Promise<ILoggedUser> {
  try {
    const { data } = await apiClient.get<ILoggedUser>("/user");
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && !error.response) {
      throw new Error("Wasn't possible to connect to the server.");
    }

    throw error;
  }
}

export async function checkEmailExists(email: string): Promise<boolean> {
  try {
    var response = await apiClient.get("/user/email-exists", {
      params: { email },
    });
    var data = response.data;
    return data.exists;
  } catch (err) {
    throw err;
  }
}
